/**
 * Theme Requirements Aggregation for Gallery Residential
 * 
 * Extends the base blue-haven theme requirements with Gallery Residential specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-blue-haven/requirements';

/**
 * Gallery Residential component requirement overrides.
 * Add requirements for any override components here.
 */
const galleryresidentialOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Gallery Residential theme.
 * Inherits from blue-haven theme and overrides with Gallery Residential components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...galleryresidentialOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
